import { render, staticRenderFns } from "./RankUsers.vue?vue&type=template&id=f95a970c&"
import script from "./RankUsers.vue?vue&type=script&lang=js&"
export * from "./RankUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports